
/**
 * 用于情感对照的对照表
 * id为TTS合成支持的情感关键词
 * face 对应的表情
 * text 对应的文本
 * bot 机器人对应的情感
 * fbx 情感对应的动作
 */
 export let emotion =[
    {
        id:'affectionate',
        text:'深情',
        face:'1f60d',
        fbx:'',
    },
    {
        id:'lyrical',
        bot:"like",
        text:'抒情',
        face:'1f61a',
        fbx:'',
    },
    {
        id:'customerservice',
        text:'热情',
        face:'1f973',
        fbx:'',
    },
    {
        id:'fearful',
        text:'温和',
        face:'1f60c',
        fbx:'',
    },
    {
        id:'angry',
        bot:"angry",
        text:'愤怒',
        face:'1f621',
        fbx:'',
    },
    {
        id:'assistant',
        text:'助手',
        face:'1f642',
        fbx:'',
    },
    {
        id:'calm',
        bot:"calm",
        text:'冷静',
        face:'1f914',
        fbx:'',
    },
    {
        id:'chat',
        text:'随意',
        face:'1f609',
        fbx:'',
    },
    {
        id:'cheerful',
        bot:"happy",
        text:'愉快',
        face:'1f600',
        fbx:'',
    },
    {
        id:'gentle',
        bot:"confused",
        text:'恐惧',
        face:'1f631',
        fbx:'',
    },
    {
        id:'newscast',
        text:'正式',
        face:'1f91d',
        fbx:'',
    },
    {
        id:'sad',
        bot:"sad",
        text:'悲伤',
        face:'1f629',
        fbx:'',
    },
    {
        id:'serious',
        text:'严肃',
        face:'1f641',
        fbx:'',
    },
    {
        id:'excited',
        bot:"excited",
        text:"兴奋",
        face:"1f973",
    }
    ,
    {
        id:'naughty',
        bot:"naughty",
        text:"调皮",
        face:"1f61d",
    }
    ,
    {
        id:'worry',
        bot:"worry",
        text:"烦闷",
        face:"1f624",
    }
    ,
    {
        id:'angry',
        bot:"despite",
        text:'瞧不起',
        face:'1f621',
        fbx:'',
    },
    {
        id:'surprise',
        bot:"surprise",
        text:'惊讶',
        face:'1f62e',
        fbx:'',
    },
    {
        id:'disappointed',
        bot:"disappointed",
        text:'失望',
        face:'1f614',
        fbx:'',
    }
]